import { render, staticRenderFns } from "./WalletEventList.vue?vue&type=template&id=4b7570d1&scoped=true&"
import script from "./WalletEventList.vue?vue&type=script&lang=js&"
export * from "./WalletEventList.vue?vue&type=script&lang=js&"
import style0 from "./WalletEventList.vue?vue&type=style&index=0&id=4b7570d1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b7570d1",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VDataTable,VRow})
